export class Substitute {

  private substituteValue: String;
  private replaceWith: String;

  constructor( substitute: String, replaceWith: String) {
    this.substituteValue = substitute;
    this.replaceWith = replaceWith;
  }

  get getSubstituteValue(): String {
    return this.substituteValue;
  }

  set setSubstituteValue(value: String) {
    this.substituteValue = value;
  }

  get getReplaceWith(): String {
    return this.replaceWith;
  }

  set setReplaceWith(value: String) {
    this.replaceWith = value;
  }
}
